/*
----------------------------
Module - main-nav
----------------------------
*/

import $ from 'jquery';
/*global fmg*/

(function () {
    'use strict';

    fmg.mainNav = function() {

        function checkPositionOfStickyMainNavWrapper() {

            // Get current position of where the top of the viewport the user is at
            var docViewTop = $(window).scrollTop();
                
            var mainNavWrapperOffsetTop = $main_nav_wrapper.offset().top;

            // Get position of where top of the main is
            var mainOffsetTop = $main.offset().top;

            // If top of viewport is past where the relative position of top of the header is, make position fixed
            if (docViewTop > mainNavWrapperOffsetTop) {

                $main_nav_wrapper.addClass("main-nav-wrapper--sticky"); // Make main nav stick to the top

            } else if (docViewTop <= mainOffsetTop) {

                // If top of viewport is at or before where the top of main + padding, make position of header relative
                // This is because alerts might live above the header so we need to lock the header back in place
                resetMainNavWrapperPosition();

            }
            
        }

        function resetMainNavWrapperPosition() {
            $main_nav_wrapper.removeClass("main-nav-wrapper--sticky");
        }

        var scrolledEvent = fmg.fn.debounce(function() {

            checkPositionOfStickyMainNavWrapper();

        }, 10);

        function toggleStickyMainNavWrapper() {
            
            checkPositionOfStickyMainNavWrapper();

            $(window).on("scroll", scrolledEvent); // Bind scroll event

        }

        function disableStickyMainNavWrapper() {
            
            resetMainNavWrapperPosition();

            $(window).off('scroll', scrolledEvent);
        }

        // When the viewport is changed, this function is called from global.js in the _global module
        function refresh() {

            if (fmg.vars.screensize > 3) {
                toggleStickyMainNavWrapper();
            } else {
                disableStickyMainNavWrapper();
            }

        }

        function setupFocusOutMainNav() {

            $main_nav.on("focusout", function(evt) {

                var $next_focused_element = $(evt.relatedTarget);
                var parent = ".main-nav";

                // When focus out of main nav evennt but manage to focus on something else outside of main nav
                // Close open menus
                if ($next_focused_element.length && !fmg.fn.isElementWithinParent($next_focused_element, parent)) {
                    closeExpandedSubmenus();
                }

            });

        }

        function setupClickEvents() {

            $(document).on("click", function(evt) {

                var $clicked_target = $(evt.target);

                if (!fmg.fn.isElementWithinParent($clicked_target, ".main-nav")) {
                    closeExpandedSubmenus();
                }
                
            });

        }

        function setupKeyboardControls() {

            $main_nav.keydown(function(evt) {
                
                // Escape key is pressed
                if (evt.which == 27) {
                    
                    // Get focused element when keydown happened
                    var $focused_element = $(evt.target);

                    var $closest_active_button = $focused_element.closest(".main-nav__menu-item").find("[aria-expanded='true']");

                    if ($closest_active_button.length) {

                        // Refocus on related button if focused element is within an expanded sub menu
                        $closest_active_button.trigger('focus');

                        // Close the expanded submenu
                        toggleSubmenu($closest_active_button, "true");

                    }
                    
                }

            });
            
        }

        function toggleSubmenu($button, is_active) {

            var $parent_menu = $button.parent();
            var $sub_menu = $button.parent().find(".main-nav__submenu");
            
            if (is_active === "false") {

                $parent_menu.addClass(menu_expanded_classname);

                // Expand submenu
                $sub_menu.slideDown("fast");

                $button.attr("aria-expanded", "true");

            } else {
                
                // Close submenu
                // Remove class only after the sub menu is closed completely
                $sub_menu.slideUp("fast", function() {
                    $parent_menu.removeClass(menu_expanded_classname);
                });

                $button.attr("aria-expanded", "false");

            }

        }

        function closeExpandedSubmenus() {

            var $active_buttons = $buttons.filter("[aria-expanded='true']");
                        
            if ($active_buttons.length) {

                toggleSubmenu($active_buttons, "true");

            }

        }

        function setupButtons() {

            $buttons.click(function(evt) {

                var $this_button = $(evt.target);

                var is_active = $this_button.attr("aria-expanded");

                // If this one hasn't been activated, close all the other sub menus (if any)
                if (is_active === "false") {
                    closeExpandedSubmenus();
                } 
                
                toggleSubmenu($this_button, is_active)

            });

        }

        function init() {

            $main_nav_wrapper = $(".main-nav-wrapper");

            if ($main_nav_wrapper.length) {

                $main = $("main");
                $main_nav = $main_nav_wrapper.find(".main-nav");                
                $buttons = $main_nav_wrapper.find(".main-nav__button");
                
                setupButtons();
                setupKeyboardControls();
                setupClickEvents();
                setupFocusOutMainNav();

            }

        }

        var $main;
        var $main_nav_wrapper;
        var $main_nav;
        var $buttons;
        var menu_expanded_classname = "main-nav__menu-item--expanded";
    
        return {
            init: init,
            refresh: refresh
        }

    }();
        
    document.addEventListener("DOMContentLoaded", function () {
        fmg.mainNav.init();
    });

}());
